import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../context/ProfileContext";
import { getAdminLandingPath } from "../utils/adminLanding";

const Home = () => {
  const navigate = useNavigate();
  const { profile, assignModule, loading } = useProfile();

  useEffect(() => {
    if (loading) return;

    // Not logged in
    if (!profile) {
      navigate("/login", { replace: true });
      return;
    }

    // Logged in
    navigate(getAdminLandingPath(profile, assignModule), {
      replace: true,
    });
  }, [loading, profile, assignModule, navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>Welcome to Udrivo</h1>
    </div>
  );
};

export default Home;
